import ApiService from "@/core/services/api.service";

// Actions
export const FETCH_AI_COMPANIES = "fetchAiCompanies";
export const FETCH_AI_COMPANY = "fetchAiCompany";
export const SAVE_AI_COMPANY = "saveAiCompany";
export const UPDATE_AI_COMPANY = "updateAiCompany";
export const DELETE_AI_COMPANY = "deleteAiCompany";
export const FETCH_AI_COMPANY_OPTIONS = "fetchAiCompanyOptions";
export const CONFIRM_AI_COMPANY = "confirmAiCompany";

// Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAiCompany";
export const SET_AI_COMPANIES = "setAiCompanies";

const state = {
  ai_companies_errors: [],
  ai_companies: [],
  isLoadingAiCompany: false
};

const getters = {
  isLoadingAiCompany() {
    return state.isLoadingAiCompany;
  },
  getAiCompanies() {
    return state.ai_companies;
  }
};

const actions = {
  [FETCH_AI_COMPANIES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-companies" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_COMPANY](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-companies", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_AI_COMPANY](context, payload) {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.post("ai-companies", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_COMPANY](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("ai-companies", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_AI_COMPANY](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("ai-companies", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_COMPANY_OPTIONS](context, apiParams = "") {
    return new Promise((resolve, reject) => {
      ApiService.get("ai-companies/options" + apiParams)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [CONFIRM_AI_COMPANY](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post(`ai-companies/${id}/confirm`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAiCompany = false;
    if (Array.isArray(errors)) {
      state.ai_companies_errors = errors;
    } else {
      state.ai_companies_errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAiCompany = value;
  },
  [SET_AI_COMPANIES](state, data) {
    state.isLoadingAiCompany = false;
    state.ai_companies = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
